<template>  
    <div class="header-wrap">
        <div class="wrapCenter">
            <nav class="navbar navbar-default" role="navigation">
                <div class="container-fluid">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse"
                            data-target="#example-navbar-collapse">
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <!-- LOGO -->
                    <div class="header-logo">
                        <!--<router-link :to="{path: '/'}" class="header-logo-link"></router-link>-->
                        <a href="/" class="header-logo-link"></a>
                    </div>
                </div>
                <div class="collapse navbar-collapse" id="example-navbar-collapse">
                    <!-- 菜单 -->
                    <ul class="header-link nav navbar-nav">
                        <li v-for="item in menus" @mouseenter="item.childShow = true" @mouseleave="item.childShow = false">
                            <router-link :to="{path: item.url}" :class="{'dropdown-toggle':item.childs, 'active': $route.path == item.url}"> {{item.name}} 
                                <i class="header-link-arrow" v-if="item.childs"></i>
                            </router-link>
                            <div class="dropdown-menu" v-if="item.childs" v-show="item.childShow">
                                <ul :style="item.childsStyle">
                                    <li v-for="child in item.childs" @click="pageSwitch()" :class="{active: $route.path == child.url}"><router-link :to="{path: child.url}"> {{ child.name }} </router-link></li>
                                </ul>
                            </div>
                            
                        </li>
                    </ul>
                </div>
                </div>
            </nav>
            
        </div>
        
    </div>
    
</template>
<script>
    export default {
        data() {
            return {
                menus: [{
                    name: "首页",
                    url: "/"
                }, {
                    name: "关于我们",
                    url: "/about/top",
                    childsStyle: "margin-left: -40px;",
                    childShow: false,
                    // childs: [{
                    //     name: "关于我们",
                    //     url: "/about/top"
                    // }, {
                    //     name: "品牌文化",
                    //     url: "/about/culture"
                    // }, {
                    //     name: "品牌价值观",
                    //     url: "/about/brand"
                    // }, {
                    //     name: "经营理念",
                    //     url: "/about/idea"
                    // }, {
                    //     name: "联系我们",
                    //     url: "/about/contact"
                    // }]
                }, {
                    name: "有线耳机",
                    url: "/earphoneList"
                }, {
                    name: "蓝牙耳机",
                    url: "/earphoneListBlue"
                // }, {
                //     name: "服务",
                //     url: "",
                //     childsStyle: " margin-left: 300px; ",
                //     childShow: false,
                //     childs: [{
                //         name: "使用说明",
                //         url: "/server/instructions"
                //     }, {
                //         name: "煲机教程",
                //         url: "/server/tutorial"
                //     }, {
                //         name: "防伪查询",
                //         url: "/server/security"
                //     }]
                }, {
                    name: "新闻资讯",
                    url: "/media"
                }]
            }
        },
        methods: {
            pageSwitch() {
                this.$emit("pageSwitch");
            }
        },
        mounted() {
            // $(document).ready(function() {
                //添加移动端事件
                $(".navbar-default .navbar-nav>li").bind('touchend', function(event) {
                    event.stopPropagation();  // 阻止事件冒泡
                    $(this).find(".dropdown-menu").slideToggle();

                });

                $(".dropdown-menu>ul>li a").bind('touchend', function(event) {
                    event.stopPropagation();
                    setTimeout(function() {
                        $(".navbar-collapse").removeClass("in");
                    }, 300)
                });



            // })

        }
    }
</script>
<style scoped>
    .header-wrap {
        position: fixed;
        height: 80px;
        width: 100%;
        background: #000000;
        z-index: 10;
        top: 0px;
    }
    
    .header-logo {
        display: inline;
        float: left;
        padding: 20px 0;
    }
    
    .header-logo-link {
        display: block;
        width: 140px;
        height: 40px;
        background-repeat: no-repeat;
        background-position: center center;
        background-image: url(../assets/img/logo4.png);
        background-size: contain;
    }
    
    .header-link {
        display: inline;
        float: right;
        white-space: nowrap;
    }
    
    .header-link li {
        display: inline;
        float: left;
    }
    
    .header-link a {
        display: block;
        padding: 30px 30px;
        line-height: 20px;
        transition: color .1s linear;
        
    }

    .navbar-default .navbar-nav>li>a{
        color: #ffffff;
    }
    
    .navbar-default .header-link a.active {
        /* color: #0044bc; */
    }
    
    .header-link-arrow {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-right: 3px #ffffff solid;
        border-bottom: 3px #ffffff solid;
        transform: rotate(45deg) translate(0, -2px);
        margin-left: 2px;
    }
    
    .navbar {
        border: none;
    }
    
    .navbar-default {
        background: #000000;
    }
    
    .navbar-default .navbar-collapse,
    .navbar-default .navbar-form {
        background: #000000;
    }
    
    .navbar {
        position: static;
    }
    
    .nav>li {
        position: static;
    }
    
    .dropdown-menu {
        min-width: 100%;
        width: 100%;
        left: 0px;
        border: none;
        border-top: 1px #666666 solid;
        display: block;
        background: #000000;
    }
    
    .dropdown-menu li {
        float: left;
    }
    
    .dropdown-menu li a {
        padding: 4px 10px;
        color: #ffffff;
    }
    
    .navbar-default .navbar-nav>li>a:focus, .navbar-default .navbar-nav>li>a:hover{
        background: transparent;
        color: #ffffff;
    }
    
    .navbar-nav>li:hover .header-link-arrow {
        /* border-color: #0044bc; */
    }
    /*.navbar-nav>li:hover .dropdown-menu{
        display: block;
    }*/
    
    .navbar-nav>li>.dropdown-menu>ul {
        /* float: right; */
        left: 50%; 
        position: relative;
    }
    
    .navbar-nav>li>.dropdown-menu>ul>li:hover a,
    .navbar-nav>li>.dropdown-menu>ul>li.active a {
        /* color: #0044bc; */
    }
    
    @media (max-width: 768px) {
        .container-fluid {
            padding: 0px;
        }
        .header-wrap {
            height: 60px;
        }
        .navbar-header {
            height: 60px;
            margin: 0;
            padding: 0 1rem;
        }
        .header-logo {
            left: 50%;
            position: absolute;
            margin-left: -2.5rem;
            padding: 10px 0;
        }
        .header-logo-link {
            width: 130px;
            height: 40px;
            background-size: contain;
        }
        .navbar-toggle {
            float: left;
            margin-top: 14px;
        }
        .navbar {
            margin-bottom: 0px;
        }
        .navbar-default .navbar-toggle .icon-bar {
            background: #ffffff;
            height: 3px;
        }
        .navbar-default .navbar-toggle {
            border: none;
        }
        .navbar-nav {
            margin: 7.5px 0px;
        }
        .header-link {
            float: none;
            display: block;
        }
        .header-link li {
            float: none;
            display: block;
            width: 100%;
            overflow: hidden;
        }
        .header-link a {
            padding: 16px 1.4rem;
            border-bottom: 1px #eeeeee solid;
        }
        .navbar-nav>li>.dropdown-menu>ul {
            float: none;
            margin-right: 0px !important;
        }
        .dropdown-menu li a {
            padding: 16px 1.4rem;
        }
        .dropdown-menu {
            position: relative;
            background: rgba(255, 255, 255, 0.3);
        }
        .navbar-collapse {
            margin-left: 0px;
            margin-right: 0px;
            padding-left: 0px;
            padding-right: 0px;
        }
        .navbar-default .navbar-toggle:focus,
        .navbar-default .navbar-toggle:hover {
            background: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/header.vue